import { render, staticRenderFns } from "./WantReceive.vue?vue&type=template&id=45401ec8&"
import script from "./WantReceive.vue?vue&type=script&lang=js&"
export * from "./WantReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports